import { InteractionStatus } from '@azure/msal-browser';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { Link, Navigate, Outlet, createFileRoute } from '@tanstack/react-router';

import VolvoPentaLogoMobile from '@/assets/logo-mobile.svg';
import VolvoPentaLogo from '@/assets/logo.svg';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import PublicFooter from '@/routes/_public/login/_components/PublicFooter';

export const Route = createFileRoute('/_public')({
  component: PublicLayout,
  errorComponent: ErrorBoundary,
  notFoundComponent: () => <div>Page Not Found asdas d</div>,
});

function PublicLayout() {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();

  // Wait for MSAL to finish handling any redirect before deciding where to go
  if (inProgress !== InteractionStatus.None) {
    return null;
  }

  // Redirect to dashboard if authenticated
  if (isAuthenticated) {
    // We need to check if user can show Dashboard
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <>
      <div className="bg-white antialiased">
        <div className="border-neutral-light fixed top-0 z-20 w-full border-b bg-white px-10 py-9 shadow-md">
          <div className="mx-auto flex w-full max-w-xl items-center justify-between">
            <Link to={'/dashboard'}>Volvo Penta Connect</Link>
            <img src={VolvoPentaLogo} alt="Volvo Penta Connect" className="hidden md:block" />
            <img src={VolvoPentaLogoMobile} alt="Volvo Penta Connect" className="md:hidden" />
            <div></div>
          </div>
        </div>

        <main className="flex-1 overflow-y-auto p-6 md:p-9">
          <Outlet />
        </main>

        {/* Footer - Fixed at bottom */}
        <PublicFooter />
      </div>
    </>
  );
}
